(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $Q9cvz._)(arr) || (0, $c4AWK._)(arr, i) || (0, $ihB7G._)(arr, i) || (0, $dNApw._)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09cbfe85151ea6c6$export$71511d61b312f219; });
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ca2848f896a6803$export$71511d61b312f219; });
function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0bc1859061deae1$export$71511d61b312f219; });
function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});

parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


// Global app entry point.
// Block-specific JS lives in blocks/{name}/script.js
// Matomo lead events. Pushed to window._paq; the MTM container
// (inc/matomo.php) registers its tracker as default, so the queue is
// sent once the container loads. Events are queued only while
// CookieYes reports Analytics consent – nothing recorded before
// consent (or after withdrawal) can be replayed.
// Contact page from Theme Options → Contact, localized in functions.php.

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");
var $8fcb3c34691f7d85$var$_window_kcaData;
var $8fcb3c34691f7d85$var$_window_kcaData_contactPath;
var $8fcb3c34691f7d85$var$CONTACT_PATH = ($8fcb3c34691f7d85$var$_window_kcaData_contactPath = ($8fcb3c34691f7d85$var$_window_kcaData = window.kcaData) === null || $8fcb3c34691f7d85$var$_window_kcaData === void 0 ? void 0 : $8fcb3c34691f7d85$var$_window_kcaData.contactPath) !== null && $8fcb3c34691f7d85$var$_window_kcaData_contactPath !== void 0 ? $8fcb3c34691f7d85$var$_window_kcaData_contactPath : '/contact-us';
var $8fcb3c34691f7d85$var$FORM_DEDUPE_MS = 2000;
var $8fcb3c34691f7d85$var$PAGE_LABELS = [
    [
        'home',
        "Contact us button \u2013 homepage"
    ],
    [
        'single-product',
        "Contact us button \u2013 product page"
    ],
    [
        'tax-product_category',
        "Contact us button \u2013 category page"
    ],
    [
        'error404',
        "Contact us button \u2013 404"
    ]
];
// Fails closed: no CookieYes API means no consent.
var $8fcb3c34691f7d85$var$hasAnalyticsConsent = function() {
    var _window_getCkyConsent_categories, _window_getCkyConsent;
    return typeof window.getCkyConsent === 'function' && ((_window_getCkyConsent = window.getCkyConsent()) === null || _window_getCkyConsent === void 0 ? void 0 : (_window_getCkyConsent_categories = _window_getCkyConsent.categories) === null || _window_getCkyConsent_categories === void 0 ? void 0 : _window_getCkyConsent_categories.analytics) === true;
};
var $8fcb3c34691f7d85$var$track = function(category, action, name) {
    if (!$8fcb3c34691f7d85$var$hasAnalyticsConsent()) return;
    /* eslint-disable no-underscore-dangle */ window._paq = window._paq || [];
    window._paq.push([
        'trackEvent',
        category,
        action,
        name
    ]);
/* eslint-enable no-underscore-dangle */ };
var $8fcb3c34691f7d85$var$isContactLink = function(link) {
    return link.hostname === window.location.hostname && link.pathname.replace(/\/$/, '') === $8fcb3c34691f7d85$var$CONTACT_PATH;
};
var $8fcb3c34691f7d85$var$contactLabel = function(link) {
    if (link.closest('.site-header, .site-nav-mobile')) return "Contact us \u2013 header";
    if (link.closest('.site-footer')) return "Contact us \u2013 footer";
    var page = $8fcb3c34691f7d85$var$PAGE_LABELS.find(function(param) {
        var _param = (0, $kB67t._)(param, 1), bodyClass = _param[0];
        return document.body.classList.contains(bodyClass);
    });
    return page ? page[1] : "Contact us \u2013 other";
};
// 1. HubSpot form (iframe) – new embed and legacy embed. Both may fire
// for one submission, hence the dedupe window.
var $8fcb3c34691f7d85$var$lastFormSubmit = 0;
var $8fcb3c34691f7d85$var$trackFormSubmit = function() {
    var now = Date.now();
    if (now - $8fcb3c34691f7d85$var$lastFormSubmit < $8fcb3c34691f7d85$var$FORM_DEDUPE_MS) return;
    $8fcb3c34691f7d85$var$lastFormSubmit = now;
    $8fcb3c34691f7d85$var$track('Lead', 'Form submitted', 'Contact page');
};
window.addEventListener('hs-form-event:on-submission:success', $8fcb3c34691f7d85$var$trackFormSubmit);
// Legacy embed posts either from the page itself (forms script, or its
// src-less iframe) or from a HubSpot-hosted iframe embedded on the page.
var $8fcb3c34691f7d85$var$HS_ORIGIN = /^https:\/\/([\w-]+\.)*(hsforms\.(com|net)|hubspot\.com)$/;
var $8fcb3c34691f7d85$var$isHubSpotMessage = function(param) {
    var origin = param.origin, source = param.source;
    if (origin !== window.location.origin && !$8fcb3c34691f7d85$var$HS_ORIGIN.test(origin)) return false;
    return source === window || (0, $2Xzd1._)(document.querySelectorAll('iframe')).some(function(frame) {
        return frame.contentWindow === source;
    });
};
window.addEventListener('message', function(event) {
    var data = event.data;
    if ((data === null || data === void 0 ? void 0 : data.type) === 'hsFormCallback' && data.eventName === 'onFormSubmitted' && $8fcb3c34691f7d85$var$isHubSpotMessage(event)) $8fcb3c34691f7d85$var$trackFormSubmit();
});
// 2. "Contact us" CTA and 3. mailto clicks.
document.addEventListener('click', function(event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    if (link.protocol === 'mailto:') {
        var email = decodeURIComponent(link.href.slice(7).split('?')[0]);
        $8fcb3c34691f7d85$var$track('Lead', 'Email click', email);
        return;
    }
    if ($8fcb3c34691f7d85$var$isContactLink(link)) $8fcb3c34691f7d85$var$track('CTA', 'Contact click', $8fcb3c34691f7d85$var$contactLabel(link));
});



})();
//# sourceMappingURL=_app.js.map
